import Main_Route from './Routes/MainRoute';
function App() {
   const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };
  const userDetails = JSON.parse(localStorage.getItem('details'));
  return (
    <>
    <div className="App">
      <Main_Route />
          
    </div>
   
    </>
    

  );
}

export default App;
